// extracted by mini-css-extract-plugin
export default {"tag":"Tc3W9Z"};